export default "__VITE_ASSET__0e3da5fe__"